import React, { useState } from 'react';
import Input from '../Input';
import ButtonLinear from '../Buttons/ButtonLinear';
import { PhoneNumberUtil } from 'google-libphonenumber';
import './styles.css';

const phoneUtil = PhoneNumberUtil.getInstance();

export default function Form({ config }) {
    const { title, subtitle, fields, cta, style } = config || {};
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});

    const handleInputChange = (field) => (value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        if (fieldErrors[field]) {
            setFieldErrors(prev => ({ ...prev, [field]: undefined }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newFieldErrors = {};

        if (fields && fields.includes('name')) {
            const name = formData.name || '';
            if (!name.trim().includes(' ') || name.trim().length < 3) {
                newFieldErrors.name = 'Insira seu nome completo.';
            }
        }

        if (fields && fields.includes('email')) {
            const email = formData.email || '';
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                newFieldErrors.email = 'Insira um email válido.';
            }
        }

        if (fields && fields.includes('phone')) {
            const phone = formData.phone || '';
            let isValid = false;
            try {
                isValid = phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
            } catch (err) {
                isValid = false;
            }
            if (!isValid) {
                newFieldErrors.phone = 'Insira um telefone válido.';
            }
        }

        if (Object.keys(newFieldErrors).length > 0) {
            setFieldErrors(newFieldErrors);
            return;
        }

        setFieldErrors({});

        if (cta?.redirect?.type === 'REQUEST') {
            const reqConfig = cta.redirect.config;
            setLoading(true);
            setError('');

            try {
                // Map fields
                const payload = {};
                Object.keys(reqConfig.fields_map || {}).forEach(key => {
                    payload[reqConfig.fields_map[key]] = formData[key] || '';
                });

                const response = await fetch(reqConfig.endpoint, {
                    method: reqConfig.type || 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    throw new Error('Erro ao enviar formulário');
                }

                if (reqConfig.onSuccess?.type === 'REDIRECT' && reqConfig.onSuccess?.config?.url) {
                    window.location.href = reqConfig.onSuccess.config.url;
                } else {
                    setSuccess(true);
                }
            } catch (err) {
                setError('Ocorreu um erro ao enviar o formulário. Tente novamente.');
            } finally {
                setLoading(false);
            }
        } else if (cta?.redirect && typeof cta.redirect === 'string') {
            window.location.href = cta.redirect;
        }
    };

    return (
        <div className="custom-form-container" style={style}>
            {(title || subtitle) && (
                <div className="custom-form-header">
                    {title && <h2 className="custom-form-title">{title}</h2>}
                    {subtitle && <p className="custom-form-subtitle">{subtitle}</p>}
                </div>
            )}

            {success ? (
                <div className="custom-form-success">
                    <div className="success-icon">✓</div>
                    <p>Enviado com sucesso!</p>
                </div>
            ) : (
                <form className="custom-form-content" onSubmit={handleSubmit}>
                    {fields && fields.includes('name') && (
                        <div className="form-field">
                            <Input.Text
                                label="Nome"
                                placeholder="Digite seu nome"
                                value={formData.name || ''}
                                onInput={handleInputChange('name')}
                                disabled={loading}
                                error={!!fieldErrors.name}
                                helper={fieldErrors.name}
                            />
                        </div>
                    )}

                    {fields && fields.includes('email') && (
                        <div className="form-field">
                            <Input.Email
                                label="Email"
                                placeholder="exemplo@email.com"
                                value={formData.email || ''}
                                onInput={handleInputChange('email')}
                                disabled={loading}
                                error={!!fieldErrors.email}
                                helper={fieldErrors.email}
                            />
                        </div>
                    )}

                    {fields && fields.includes('phone') && (
                        <div className="form-field">
                            <Input.Phone
                                label="Telefone"
                                value={formData.phone || ''}
                                onInput={handleInputChange('phone')}
                                disabled={loading}
                                error={!!fieldErrors.phone}
                                helper={fieldErrors.phone}
                            />
                        </div>
                    )}

                    {error && <div className="custom-form-error">{error}</div>}

                    <ButtonLinear
                        type="submit"
                        className={`custom-form-submit-btn ${loading ? 'loading' : ''}`}
                        disabled={loading}
                        config={{
                            text: loading ? 'Enviando...' : (cta?.text || 'Enviar')
                        }}
                    />
                </form>
            )}
        </div>
    );
}
